import { Injectable } from '@angular/core';
import { HostService } from './host.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Cacheable } from "ts-cacheable"


@Injectable({
  providedIn: "root",
})
export class ConstatService {
  constructor(private http: HttpClient, private getAuth: HostService) {}

  addconstat(obj: any) {
    let headers = new HttpHeaders();
    headers.append('Content-Type','multipart/form-data');
    headers.append('Accept','application/json');
    return this.http.post(this.getAuth.gethttps() + "addconstat", obj,{headers:headers});
  }

  showConstatPro(val: any) {
    let obj = {
      idUser: val,
    };
    return this.http.post(this.getAuth.gethttps() + "showConstatPro", obj);
  }

  @Cacheable()
  showAllConstatPro() {
    return this.http.get(this.getAuth.gethttps() + "showAllConstatPro");
  }
  
  updateConstat(val: any) {
    
    return this.http.post(this.getAuth.gethttps() + "updateConstat", val);

  }

  @Cacheable()
  showOneconstat(val: any) {
  
    return this.http.get(this.getAuth.gethttps() + "showOneconstat/"+val);

  }

  @Cacheable()
  elemtnConstat() {
     return this.http.get(this.getAuth.gethttps() + "elementConstat");
  }

  deleteConstat(id:number) {
    return this.http.get(this.getAuth.gethttps() + "deleteConstat/"+id);
  }

  updateStatusConstat(val:Object)
  {
    return this.http.post(this.getAuth.gethttps() + "changeStatusConstat",val);
  }
  
}
